

















import { Component, Mixins } from "vue-property-decorator";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import { FormatStructureEditableMixin } from "../../mixins";

@Component
export default class FormatPageOrderTool extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
}
